import {
  getRoleAll,
  getRoleID,
  newRole,
  updateRole,
  asignRole
} from "../services/rolServices";

const dataInicial = {
  array: [],
  exito: 0,
  idRol: 0,
  role: {},
};

const POST_ROLES_ADD = "POST_ROLES_ADD";
const GET_ROLES_ALL = "GET_ROLES_ALL";
const GET_ROLES_BY_ID = "GET_ROLES_BY_ID";
const PUT_ROLES_ACTULIZA = "PUT_ROLES_ACTULIZA";
const CLEAR_ROLES_ALL = "CLEAR_ROLES_ALL";
const POST_ROLES_PERMISO = "POST_ROLES_PERMISO";

export default function rolesReducer(state = dataInicial, action) {
  switch (action.type) {
    case POST_ROLES_PERMISO:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    case PUT_ROLES_ACTULIZA:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    case GET_ROLES_BY_ID:
      return {
        ...state,
        role: action.payload.role,
      };
    case CLEAR_ROLES_ALL:
      return {
        ...state,
        array: action.payload.array,
        role: action.payload.role,
        exito: action.payload.exito,
      };
    case GET_ROLES_ALL:
      return {
        ...state,
        array: action.payload.array,
      };
    case POST_ROLES_ADD:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    default:
      return state;
  }
}
export const actulizaRolAction =
  (idRole, payload) => async (dispatch, getSate) => {
    const response = await updateRole({ idRole, payload });
    const newRoles = await getRoleAll();
    dispatch({
      type: PUT_ROLES_ACTULIZA,
      payload: {
        array: newRoles,
        exito: 1,
      },
    });
    return response;
  };

export const altaRolAction = (payload) => async (dispatch, getSate) => {
  const response = await newRole({ payload });
  const newRoles = await getRoleAll();
  dispatch({
    type: POST_ROLES_ADD,
    payload: {
      array: newRoles,
      exito: 1,
    },
  });
  return response;
};

export const obtenerRolesAllAction = () => async (dispatch) => {
  const roles = await getRoleAll();
  dispatch({
    type: GET_ROLES_ALL,
    payload: {
      array: roles,
    },
  });
  return roles;
};

export const obtnerRolesByIdAction = (idRole) => async (dispatch) => {
  const role = await getRoleID({ idRole });
  dispatch({
    type: GET_ROLES_BY_ID,
    payload: {
      role: role,
    },
  });
  return role;
};

export const asignarRolPermisosAction = (payload) => async (dispatch) => {
  const response = await asignRole({ payload });
  const newRoles = await getRoleAll();
  dispatch({
    type: POST_ROLES_PERMISO,
    payload: {
      array: newRoles,
      exito: 1,
    },
  });
  return response;
};

export const clearState = () => (dispatch) => {
  dispatch({
    type: CLEAR_ROLES_ALL,
    payload: {
      dataInicial,
    },
  });
};
